export function renderPhoneNumber (number: string | number): string {
    if (typeof number === 'number') {
        const str = `${number}`;
        return `${str.slice(0,3)}-${str.slice(3,6)}-${str.slice(6,9)}`;
    }
    return number;
}